export default {
  sm: `
  우리가 업로드한 사진과 동영상, 문서는
  여러 통신사의 네트워크를 거쳐 인터넷으로
  흘러갑니다. 인터넷에 모인 데이터는 또다시
  다양한 네트워크 장비를 통해 데이터센터에
  저장됩니다.
  `,
  md: `
  우리가 업로드한 사진과 동영상, 문서는
  여러 통신사의 네트워크를 거쳐 인터넷으로
  흘러갑니다. 인터넷에 모인 데이터는 또다시 다양한
  네트워크 장비를 통해 데이터센터에 저장됩니다.
  `,
  lg: `
  우리가 업로드한 사진과 동영상, 문서는 여러 통신사의 네트워크를 거쳐
  인터넷으로 흘러갑니다. 인터넷에 모인 데이터는 또다시 다양한 네트워크
  장비를 통해 데이터센터에 저장됩니다.
  `,
  xxl: `
  우리가 업로드한 사진과 동영상, 문서는 여러 통신사의 네트워크를 거쳐
  인터넷으로 흘러갑니다. 인터넷에 모인 데이터는 또다시 다양한
  네트워크 장비를 통해 데이터센터에 저장됩니다.
  `
};
